import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["name"];
import React, { memo } from 'react';
import { Icon as IconHoi } from '@Sage/hoi-poi-ui';
import { default as Accounts } from "./AccountsIcon";
import { default as Activities } from "./ActivitiesIcon";
import { default as Analytics } from "./AnalyticsIcon";
import { default as AnalyticsPro } from "./AnalyticsProIcon";
import { default as AvoidDuplicates } from "./AvoidDuplicatesIcon";
import { default as Calendar } from "./CalendarIcon";
import { default as Campaigns } from "./CampaignsIcon";
import { default as Contacts } from "./ContactsIcon";
import { default as Credentials } from "./CredentialsIcon";
import { default as Dashboard } from "./DashboardIcon";
import { default as Documents } from "./DocumentsIcon";
import { default as Download } from "./DownloadIcon";
import { default as Excel } from "./ExcelIcon";
import { default as Fields } from "./FieldsIcon";
import { default as FieldsValidationsIcon } from "./FieldsValidationsIcon";
import { default as Force } from "./ForceIcon";
import { default as Forms } from "./FormsIcon";
import { default as Functions } from "./FunctionsIcon";
import { default as Goals } from "./GoalsIcon";
import { default as ImportsAlt } from "./ImportsAltIcon";
import { default as Imports } from "./ImportsIcon";
import { default as List } from "./ListIcon";
import { default as Literals } from "./LiteralsIcon";
import { default as News } from "./NewsIcon";
import { default as Opportunities } from "./OpportunitiesIcon";
import { default as Parameters } from "./ParametersIcon";
import { default as Products } from "./ProductsIcon";
import { default as Quotes } from "./QuotesIcon";
import { default as Reports } from "./ReportsIcon";
import { default as Roles } from "./RolesIcon";
import { default as SalesOrders } from "./SalesOrdersIcon";
import { default as Sandbox } from "./SandboxIcon";
import { default as Upload } from "./UploadIcon";
import { default as Users } from "./UsersIcon";
import { default as Widgets } from "./WidgetsIcon";
import { default as Crons } from "./CronsIcon";
import { default as WorkSpace } from "./WorkSpaceIcon";
import { default as TrialIcon } from "./TrialIcon";
const Icon = _ref => {
  let {
      name
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return {
    accounts: /*#__PURE__*/React.createElement(Accounts, props),
    activities: /*#__PURE__*/React.createElement(Activities, props),
    analytics: /*#__PURE__*/React.createElement(Analytics, props),
    analyticsPro: /*#__PURE__*/React.createElement(AnalyticsPro, props),
    avoidDuplicates: /*#__PURE__*/React.createElement(AvoidDuplicates, props),
    calendar: /*#__PURE__*/React.createElement(Calendar, props),
    campaigns: /*#__PURE__*/React.createElement(Campaigns, props),
    contacts: /*#__PURE__*/React.createElement(Contacts, props),
    credentials: /*#__PURE__*/React.createElement(Credentials, props),
    dashboard: /*#__PURE__*/React.createElement(Dashboard, props),
    documents: /*#__PURE__*/React.createElement(Documents, props),
    download: /*#__PURE__*/React.createElement(Download, props),
    excel: /*#__PURE__*/React.createElement(Excel, props),
    fields: /*#__PURE__*/React.createElement(Fields, props),
    fieldsValidations: /*#__PURE__*/React.createElement(FieldsValidationsIcon, props),
    force: /*#__PURE__*/React.createElement(Force, props),
    forms: /*#__PURE__*/React.createElement(Forms, props),
    functions: /*#__PURE__*/React.createElement(Functions, props),
    goals: /*#__PURE__*/React.createElement(Goals, props),
    importsAlt: /*#__PURE__*/React.createElement(ImportsAlt, props),
    imports: /*#__PURE__*/React.createElement(Imports, props),
    list: /*#__PURE__*/React.createElement(List, props),
    literals: /*#__PURE__*/React.createElement(Literals, props),
    news: /*#__PURE__*/React.createElement(News, props),
    opportunities: /*#__PURE__*/React.createElement(Opportunities, props),
    parameters: /*#__PURE__*/React.createElement(Parameters, props),
    products: /*#__PURE__*/React.createElement(Products, props),
    quotes: /*#__PURE__*/React.createElement(Quotes, props),
    reports: /*#__PURE__*/React.createElement(Reports, props),
    roles: /*#__PURE__*/React.createElement(Roles, props),
    salesOrders: /*#__PURE__*/React.createElement(SalesOrders, props),
    sandbox: /*#__PURE__*/React.createElement(Sandbox, props),
    upload: /*#__PURE__*/React.createElement(Upload, props),
    users: /*#__PURE__*/React.createElement(Users, props),
    widgets: /*#__PURE__*/React.createElement(Widgets, props),
    crons: /*#__PURE__*/React.createElement(Crons, props),
    workspace: /*#__PURE__*/React.createElement(WorkSpace, props),
    trialIcon: /*#__PURE__*/React.createElement(TrialIcon, props),
    dashboardWeb: /*#__PURE__*/React.createElement(IconHoi, _extends({
      name: "dashboard"
    }, props)),
    integrations: /*#__PURE__*/React.createElement(IconHoi, _extends({
      name: "integrations"
    }, props))
  }[name] || `Missing icon ${name}`;
};
export default /*#__PURE__*/memo(Icon);